import { render } from "./ClaimDeviceInfo.vue?vue&type=template&id=1be984c2&scoped=true&ts=true"
import script from "./ClaimDeviceInfo.vue?vue&type=script&lang=ts"
export * from "./ClaimDeviceInfo.vue?vue&type=script&lang=ts"

import "./ClaimDeviceInfo.vue?vue&type=style&index=0&id=1be984c2&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1be984c2"]])

export default __exports__